<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  .contain{
      padding: 20px 20px;
  }
  body{
    padding-right: 0 !important;
    //  display:inline-block;//将右侧内联元素变成块级，滚动条出现在下拉列表上
    overflow:overlay    //隐藏滚动条
  }
</style>
